export default __webpack_public_path__ + "static/media/higher_primary_logo_url_reversed_1.a32ddc56.svg";